import { Contact } from '../contact';
export class Testentity {
    constructor(
        public id?: number,
        public name?: string,
        public description?: string,
        public myNumber?: number,
        public myZonedDateTime?: any,
        public myLocalDate?: any,
        public contact?: Contact,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity.model.ts